<template>
  <div class="table-wrapper cover-content project-list">
    <Row>
      <Col :span="2">
        <span>{{ title }}</span>
      </Col>
      <Col :span="2">
        <span
          @click="pushSuccessClick(0)"
          class="spanTitle"
          :class="currentActive == 0 ? 'active' : ''"
          >推送成功：{{ pushSuccess }}</span
        >
      </Col>
      <Col :span="2">
        <span
          @click="pushSuccessClick(-1)"
          class="spanTitle"
          :class="currentActive == -1 ? 'active' : ''"
          >推送失败：{{ pushFail }}</span
        >
      </Col>
      <Col :span="2">
        <Button type="primary" size="small" :disabled="disabled" @click="pushAll">
          全部推送
        </Button>
      </Col>
      <Col :span="8">
        <Row>
          <Col :span="6" style="line-height:24px">
            选择配置的接口:
          </Col>
          <Col :span="8" style="line-height:24px">
            <Select
              v-model="pushModel"
              clearable
              placeholder="请选配置的接口"
              @on-change="changeSelect"
            >
              <Option
                :value="item.id"
                v-for="(item, index) in pushList"
                :key="index"
                >{{ item.systemName }}</Option
              >
            </Select>
          </Col>
        </Row>
      </Col>
      <Col :span="8" v-if="method === 'addWorkerAttendance'">
        <Row>
          <Col :span="4" style="line-height:24px;">
            推送时间:
          </Col>
          <Col :span="8">
            <DatePicker
              v-model="startDate"
              type="date"
              placeholder="请选择起始日期"
              @on-change="handleStartDate"
              split-panels
              class="dataClass"
              :options="{
                disabledDate: disabledDateStart,
              }"
            ></DatePicker>
          </Col>
          <Col :span="8" style="margin-left:10px">
            <DatePicker
              v-model="endDate"
              type="date"
              placeholder="请选择结束日期"
              @on-change="handleEndDate"
              split-panels
              class="dataClass"
              :options="{
                disabledDate: disabledDateEnd,
              }"
            ></DatePicker>
          </Col>
        </Row>
      </Col>
    </Row>
    <!-- </high-search> -->
    <!-- @on-selection-change="selected" -->
    <Table
      style="margin-top:10px;"
      :loading="loading"
      :columns="tableColumns"
      :data="tableData"
      highlight-row
    >
      <template slot-scope="{ row, index }" slot="buildNumFlag">
        <div v-if="row.buildNumFlag == 1">已办理施工许可证</div>
        <div v-else>正在办理施工许可证</div>
      </template>
      <template slot-scope="{ row, index }" slot="startReportFlag">
        <div v-if="row.buildNumFlag != 1 && row.startReportFlag == 1">
          已办理开工报告
        </div>
        <div v-if="row.buildNumFlag != 1 && row.startReportFlag != 1">
          正在办理开工报告
        </div>
      </template>
      <template slot-scope="{ row, index }" slot="action">
        <span
          v-if="row.asyncResult === '-1'"
          class="pointer"
          style="margin-left:8px;"
          @click="handleDeal(row)"
          >重新推送</span
        >
      </template>
    </Table>
    <div class="page">
      <Page
        :total="totalCount"
        :page-size="pageSize"
        :current="page"
        @on-change="changePage"
        @on-page-size-change="pageSizeChange"
        show-elevator
        show-sizer
        show-total
        transfer
      >
      </Page>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import tableMixin from "@/components/tableMixin";
export default {
  mixins: [tableMixin],
  data() {
    return {
      endDate: "",
      startDate: "",
      currentActive: 0,
      disabled: true,
      open: false,
      title: "",
      pushSuccess: "",
      pushFail: "",
      typePush: 0,
      tableColumns: [
        // {
        //   type: "selection",
        //   width: 60,
        //   align: "center",
        // },
        // {
        //   title: "系统名称",
        //   key: "systemName",
        //   minWidth: 70,
        //   tooltip: true,
        //   align: "left"
        // },
        {
          title: "方法名称",
          key: "methodName",
          minWidth: 180,
          tooltip: true,
          align: "left"
        },
        {
          title: "发送数据",
          key: "sendData",
          minWidth: 70,
          tooltip: true,
          align: "left"
        },
        {
          title: "同步结果",
          key: "resultData",
          minWidth: 180,
          tooltip: true,
          align: "left"
        },
        {
          title: "异步返回状态",
          key: "asyncResult",
          minWidth: 100,
          tooltip: true,
          align: "left"
        },
        {
          title: "异步结果",
          key: "asyncResultData",
          minWidth: 180,
          tooltip: true,
          align: "left"
        },
        {
          title: "推送日期",
          key: "pushTime",
          minWidth: 180,
          tooltip: true,
          align: "left"
        },

        {
          title: "操作",
          slot: "action",
          align: "center",
          width: 210,
        },
      ],
      tableData: [],
      exportData: {},
      projectId: "",
      method: "",
      pushList: [],
      pushModel: "",
      date: "",
    };
  },
  computed: {
    ...mapState(["area"]),
    ...mapGetters(["projectStatus", "projectCatetory"]),
  },
  created() {
    this.endDate = new Date();
    this.startDate = new Date(new Date().getTime() - 7 * 24 * 60 * 60 * 1000);
    this.currentActive = 0;
    this.title = this.$route.query.title;
    this.projectId = this.$route.query.projectId;
    this.method = this.$route.query.type;
    this.pushFail = this.$route.query.pushFail;
    this.pushSuccess = this.$route.query.pushSuccess;
    console.log(this.method,77777)
    this.getPushList();
  },
  mounted() {},
  watch: {},
  methods: {
    //时间选择
    handleStartDate(val) {
      this.startDate = val;
      this.getTableDatas()
    },
    handleEndDate(val) {
      this.endDate= val;
      this.getTableDatas()
    },
    disabledDateStart(time) {
      let beginDateVal = this.endDate.getTime();
      console.log(beginDateVal)
      if (beginDateVal) {
        return (
          time.getTime() > beginDateVal ||
          new Date(this.endDate).getTime() -
            time.getTime() -
            7 * 24 * 60 * 60 * 1000 >
            0
        );
      } else {
        return new Date(this.endDate).getTime() -
            time.getTime() -
            7 * 24 * 60 * 60 * 1000 >
            0;
      }
    },
    // 设置默认时间
    disabledDateEnd(time) {
      return time.getTime() > Date.now();
    },
    // 获取系统列表
    getPushList() {
      this.axios({
        method: "get",
        url: "/push/pushSystemInfo",
      }).then((res) => {
        this.pushList = res.data.data;
        this.pushModel = this.pushList[0].id;
        this.getTableDatas();
        console.log("pushlist", this.pushList);
      });
    },
    pushSuccessClick(val) {
      console.log(val, 3333333);
      this.typePush = val;
      this.currentActive = val;
      this.getTableDatas();
      if (val === -1) {
        this.disabled = false;
      } else {
        this.disabled = true;
      }
    },
    //切换select
    changeSelect(val) {
      this.pushModel = val;
      this.getTableDatas();
    },
    //点击单挑重新推送
    handleDeal(row) {
      let param = {
        optId: row.optId,
        method: this.method,
        projectId: this.projectId,
        systemId: this.pushModel,
        sendData: row.sendData,
      };
      this.exportData = param;
      this.loading = true;
      this.axios({
        method: "post",
        url: "/push/pushAgainSingle",
        data: param,
      })
        .then((response) => {
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    //全部推送
    pushAll(){
      this.loading =true
       let param = {
        method: this.method,
        projectId: this.projectId,
        systemId: this.pushModel,
        startDate: this.startDate,
        endDate:this.endDate
      };
      this.exportData = param;
      this.loading = false;
      this.axios({
        method: "post",
        url: "/push/pushAgainAll",
        data: param,
      }).then((res)=>{

      })

    },
    /*获取表格数据*/
    getTableDatas() {
      let param = {
        pageSize: this.pageSize,
        pageNo: this.page,
        method: this.method,
        projectId: this.projectId,
        type: this.typePush,
        systemId: this.pushModel,
        startDate: this.startDate,
        endDate:this.endDate
      };
      this.exportData = param;
      this.loading = true;
      this.axios({
        method: "post",
        url: "/push/typePushInfoDetail",
        data: param,
      })
        .then((response) => {
          this.loading = false;
          if (response.data.success) {
            this.totalCount = response.data.data.total;
            this.tableData = response.data.data.records;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
      /*新页数*/
        changePage(value) {
            this.page=value;
            this.getTableDatas();
        },
        /*每页的条数*/
        pageSizeChange(value){
            this.pageSize=value;
            this.page=1;
            this.getTableDatas();
        },
  },
};
</script>
<style scoped>
.active {
  color: #2d8cf0;
}
.spanTitle {
  cursor: pointer;
}
</style>
